module.exports = __webpack_public_path__ + "static/media/user-icon.5d703e11.svg";